import React from 'react';
import Home from './pages/Home';
import UniverseBackground from './components/UniverseBackground/UniverseBackground';
import './App.css';

function App() {
  return (
    <div className="App">
      <UniverseBackground />
      <Home />
    </div>
  );
}

export default App;
